/**
 * @fileoverview A aba Testar do agente: a pessoa conversa como um cliente e a IA
 * responde com o que está salvo, pelo mesmo caminho da conversa real, sem
 * ações de verdade (POST /ai-agents/:agentId/test-chat). O agente novo precisa
 * ser salvo antes; com alterações não salvas, o teste usa a versão salva.
 */

import React, { useEffect, useRef, useState } from "react";
import { RotateCcw, Send } from "lucide-react";

import { i18n } from "../../../../translate/i18n";
import useTestChat from "../../../../hooks/useTestChat";
import useStyles from "../TriageManager/styles";
import SectionTitle from "../TriageManager/InfoTip";
import useAgentStyles from "./styles";

const t = (key, values) => i18n.t(`agentManager.editor.test.${key}`, values);

const TestTab = ({ agent, dirty }) => {
  const classes = useStyles();
  const agentClasses = useAgentStyles();
  const { messages, loading, send, clear } = useTestChat(agent?.id, { errorText: t("error") });
  const [input, setInput] = useState("");
  const endRef = useRef(null);

  useEffect(() => {
    if (endRef.current) endRef.current.scrollIntoView({ block: "end", behavior: "smooth" });
  }, [messages, loading]);

  if (!agent) return <div className={agentClasses.note}>{t("newFirst")}</div>;

  const submit = async (event) => {
    event.preventDefault();
    const text = input.trim();
    if (!text || loading) return;
    setInput("");
    await send(text);
  };

  return (
    <div className={agentClasses.section}>
      <div className={agentClasses.knowledgeHead}>
        <SectionTitle title={t("title")} info={t("info")} />
        <button type="button" className={classes.btnGhost} onClick={clear} disabled={messages.length === 0}>
          <RotateCcw /> {t("clear")}
        </button>
      </div>
      {dirty && <div className={agentClasses.warnNote}>{t("saveFirst")}</div>}
      <div className={agentClasses.chat}>
        <div className={agentClasses.chatMessages} aria-live="polite">
          {messages.length === 0 && !loading && <div className={agentClasses.chatEmpty}>{t("empty")}</div>}
          {messages.map((message) => (
            <div
              key={message.id}
              className={`${agentClasses.bubble} ${message.role === "user" ? agentClasses.bubbleUser : agentClasses.bubbleAi} ${message.isError ? agentClasses.bubbleError : ""}`}
            >
              {message.content}
              {message.files && message.files.length > 0 && <div className={agentClasses.bubbleFiles}>{t("files", { files: message.files.join(", ") })}</div>}
            </div>
          ))}
          {loading && (
            <div className={agentClasses.typing} aria-hidden="true">
              <span />
              <span />
              <span />
            </div>
          )}
          <div ref={endRef} />
        </div>
        <form className={agentClasses.chatInputRow} onSubmit={submit}>
          <input className={agentClasses.chatInput} value={input} onChange={(event) => setInput(event.target.value)} placeholder={t("placeholder")} aria-label={t("placeholder")} />
          <button type="submit" className={classes.btnPrimary} disabled={!input.trim() || loading} aria-label={t("send")}>
            <Send />
          </button>
        </form>
      </div>
    </div>
  );
};

export default TestTab;
